import React from 'react';

import { resetLevel } from '../../../../../../state/_actions';

import { usePane, useCreatorLevel } from '../../../../selectors/index.hooks';

import { useAppDispatch } from '../../../../../../hooks';
import TaskLinkageForm from '../../../../../../features/TaskForm/components/TaskLinkageForm';

const TaskLinkagePreview = () => {
    const dispatch = useAppDispatch();

    const creatorLevel = useCreatorLevel();
    const pane = usePane();

    const handleCloseClick = () => {
        dispatch(resetLevel(creatorLevel));
    };

    return (
        <TaskLinkageForm
            action={pane?.previewAction}
            handleCloseClick={handleCloseClick}
        />
    );
};

export default TaskLinkagePreview;
